export default __webpack_public_path__ + "static/media/talsiker.6b8bd3e2.jpg";